import React,{useState,useEffect} from "react";
import { useNavigate,useLocation } from "react-router-dom";
import "../join/choose.css";
import Head from "../../Header/head";
import { useContext } from "react";
import { WebsocketContext } from "../../../websocket/context";
import  secureLocalStorage  from  "react-secure-storage";
import axiosInstance from "../../../services/axios";
import LoadingSpinner from "../../loader/spinner";
import { useForm } from "react-hook-form";
import { useWs } from "../../../websocket/test";
import { useSelector,useDispatch } from "react-redux";
import { RoomIdProvider } from "../../../redux/actions/websocket_actions/roomId_action";
import { ToastContainer, toast } from 'react-toastify';

function ChooseSide(){
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();

    const notificaton = (message)=>{
        toast(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
    }

    const location = useLocation();
    const dispatch = useDispatch();
    const {roomId} = useSelector((state)=>state.roomIdReducer);

    const debate_id = location.state.debate_id
    const room_id = location.state.room_id
    const code = location.state.code


    if(roomId === null){
        dispatch(RoomIdProvider(room_id));

    }

    const [ready, val, send] = useContext(WebsocketContext); 


 

    const [virtual_id,setVirtualId]=useState();
    const [start,setStart] = useState(false);
    const [selected, setSelected] = useState();
    const [room_exist,setroomExist] = useState();
    const navigate = useNavigate();



    useEffect(()=>{
        var temp = JSON.parse(val)
        const fetchData = async () => {
            try {
              const response = await axiosInstance.get(`/check/start/${debate_id}`);
              setStart(response.data.start);
              setVirtualId(response.data.virtual_id);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
        if(temp.action === 'start'){
            fetchData()
        }
    },[val])

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axiosInstance.get(`/check/start/${debate_id}`);
            setStart(response.data.start);
            setVirtualId(response.data.virtual_id);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      
        fetchData();
      }, []);

    
    const onSubmit = async ()=>{
        try{
            await axiosInstance.get(`join/check/member/count/`,{params:{code:code,team:selected}}).then((res)=>{
                if(res.data.room_exist){
                    axiosInstance.put(`/choosed/side/`,{"side":selected,"virtual_id":virtual_id,"code":code}).then((res)=>
                    {
                        if(res.data){
                            send(JSON.stringify({action:"joined_member"}))
                            navigate("/participants",{state:{code:code,room_id:room_id,team_side:selected,virtual_id:virtual_id}})
                        
                        }
                        if(!res.data){
                            notificaton("Something Went Wrong");
                        }
                    }
                    );
                }
                if(!res.data.room_exist){
                    notificaton('This room is full');
                }

            });
        }
        catch(err){
            throw(err)
        }
        // console.log(room_exist)
        // if(room_exist){
        //     console.log("inside true")
        //     send(JSON.stringify({action:"joining",data:true}));
        //     try{
        //         await axiosInstance.put(`/choosed/side/`,{"side":selected,"virtual_id":virtual_id,"code":code}).then(navigate("/participants",{state:{code:code,room_id:room_id}}));
        //     }
        //     catch (err){
        //         throw(err)
        //     }
        // }
        // if(!room_exist){
        //     notificaton();
        // }
      
    }
   
    const selectTeam = async (team)=>{
        setSelected(team)
    }

    return(
        <>
        <Head/>
        {start==false ?

        <LoadingSpinner/>:
        
        <>
        <h1>Select Team</h1>

        <div className="team-container" >
            <div className={selected === "left_team" ? "team-card selected" :"team-card"} onClick={()=>selectTeam("left_team")} >
                <img src={process.env.PUBLIC_URL+'img/martial-arts.png'} alt="Team 1" />
                <h2>Team 1</h2>
                <p>Description of Team 1</p>
            </div>
            <div className={selected === "right_team" ? "team-card selected" :"team-card"} onClick={()=>selectTeam("right_team")} >
                <img src={process.env.PUBLIC_URL+'img/martial-arts-right.png'} alt="Team 1" />
                <h2>Team 2</h2>
                <p>Description of Team 2</p>
            </div>
        </div>
        <form className ="team-form" method="POST" onSubmit={handleSubmit(onSubmit)}>
            <input type="hidden" id="selectedTeam" name="selectedTeam"/>
            <input type="submit" value="Join Team"/>
        </form>
        </>
        }

        </>
    );
}

export default ChooseSide;